
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e710e492&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Introduction.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/introduction.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-e710e492!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/introduction.pug"),
  /* scopeId */
  "data-v-e710e492",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Introduction.vue
// module id = 1315
// module chunks = 1